import React, { useContext } from 'react';
import { IApkContext, ApkContext } from '../../../apkState/apkContext';
import Text from 'components/Text/Text';
import { Checkbox } from 'antd';
import style from './UnassignedApkCheckBox.module.scss';

const UnassignedApkCheckBox: React.FC = () => {
	const { toggleUnassignedApk, isUnassignedApk } = useContext<IApkContext>(ApkContext);

	return (
		<Checkbox
			className={style.container}
			onChange={toggleUnassignedApk}
			checked={isUnassignedApk}
			data-test="UnassignedApkCheckBox">
			<Text translationNameSpace="listing" translationKey="unassignedTabletAppLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedApkCheckBox;
